// Resuelve el tenant de ESTE subdominio (Rediseño mayor 2026-08-31, Módulo
// C) — solo para pintar branding en el landing de acceso antes de loguearse.
// No fuerza ningún projectId de Medplum: verificado en vivo que
// packages/hce ya loguea correctamente a distintos tenants sin pasarlo
// nunca, Medplum lo resuelve solo por la ProjectMembership del email.
import { useEffect, useState } from 'react';
import { resolverTenantPorSubdominio, type TenantPorSubdominio } from '@/lib/hceVault';

export type EstadoTenantActual =
  | { estado: 'cargando' }
  | { estado: 'ok'; tenant: TenantPorSubdominio }
  | { estado: 'no-encontrado' };

export function useTenantActual(): EstadoTenantActual {
  const [estado, setEstado] = useState<EstadoTenantActual>({ estado: 'cargando' });

  useEffect(() => {
    let cancelado = false;
    resolverTenantPorSubdominio(window.location.hostname).then((tenant) => {
      if (cancelado) return;
      setEstado(tenant ? { estado: 'ok', tenant } : { estado: 'no-encontrado' });
    });
    return () => {
      cancelado = true;
    };
  }, []);

  return estado;
}
